import React, { useState } from 'react';

// A password field with a built-in "Show / Hide" toggle, so a teacher can see
// exactly what she typed and rule out a typo. Drop-in replacement for a plain
// <input type="password" value onChange placeholder />.
interface Props {
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  placeholder?: string;
  autoComplete?: string;
}

export default function PasswordInput({ value, onChange, placeholder, autoComplete }: Props) {
  const [show, setShow] = useState(false);
  return (
    <div style={{ position: 'relative' }}>
      <input
        type={show ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete={autoComplete}
        style={{ paddingRight: 64, width: '100%' }}
      />
      <button
        type="button"
        onClick={() => setShow(s => !s)}
        aria-label={show ? 'Hide password' : 'Show password'}
        style={{
          position: 'absolute', top: '50%', right: 12, transform: 'translateY(-50%)',
          background: 'none', border: 'none', cursor: 'pointer',
          color: 'var(--teal)', fontSize: 13, fontWeight: 600, padding: 4,
        }}
      >
        {show ? 'Hide' : 'Show'}
      </button>
    </div>
  );
}
